import React, { useContext } from "react";
import Receipt from "./Receipt";
import Sales from "./Sales";
import { Page, Document, PDFViewer } from "@react-pdf/renderer";
import AppContext from "AppContext";
import currencies from "utils/static/currencies";

function Report({ reportProps, reportType }) {
    const { configurations } = useContext(AppContext);
    const currencyConfig = configurations.find((config) => config.id === "general_currency");
    const currencyIsoCode = currencyConfig?.value;
    const currency = currencies.find((c) => c.isoCode === currencyIsoCode);

    if (reportType === "receipt") {
        return (
            <PDFViewer width="100%" height="900px">
                <Receipt {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "sales") {
        return (
            <PDFViewer width="100%" height="900px">
                <Sales {...reportProps} currency={currency} />
            </PDFViewer>
        );
    }

    if (reportType === "sales-per-users") {
        return (
            <PDFViewer width="100%" height="900px">
                <Sales {...reportProps} withUsers currency={currency} />
            </PDFViewer>
        );
    }

    return (
        <PDFViewer width="100%" height="900px">
            <Document>
                <Page size="A4"></Page>
            </Document>
        </PDFViewer>
    );
}

export default Report;
